import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { BpasClientOutput } from '@ddt-web/domain';
import { UntilDestroy } from '@ngneat/until-destroy';

import { PdfReportDetailsComponent } from '../pdf-report-details/pdf-report-details.component';

@UntilDestroy()
@Component({
	selector: 'ac-pdf-bpas-report-details',
	templateUrl: './pdf-bpas-report-details.component.html',
	styleUrls: ['./pdf-bpas-report-details.component.scss']
})
export class PdfBpasReportDetailsComponent extends PdfReportDetailsComponent implements AfterViewInit, OnInit {
	@Input() public model: BpasClientOutput;

	public audienceValuesArray: string[];

	constructor(private contentService: ContentService) {
		super();
	}

	public ngOnInit(): void {
		const audienceValues: string = this.contentService.get('BPAS_AUDIENCE_ARRAY', 'FOR PROFESSIONAL/QUALIFIED INVESTORS ONLY');
		this.audienceValuesArray = audienceValues ? audienceValues.split(',').map(val => val.trim()) : [];
		this.model.audience = this.audienceValuesArray[0];
	}

	public ngAfterViewInit(): void {
		super.ngAfterViewInit();
	}

}
